var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 0)?_c('div',{staticClass:"category-section mb-5",attrs:{"id":"special-deals"}},[_c('LayoutCard',[_c('div',{staticClass:"mb-4 tp-text-subtitle-bold"},[_vm._v(_vm._s(_vm.$t('Special Deals')))]),_vm._l((_vm.items),function(item,index){return _c('menu-item',_vm._b({key:index},'menu-item',item,false))})],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }